/* =========================================================
   Vibe Wholesale Catalog — merged:
   - Original fetchSheet, groupByBaseSKU, makeCard
   - New: mini totals, saved carts, CSV import/paste,
          improved order list syncing (both ways)
   ========================================================= */

/* ===== BOOT GUARD + IIFE ===== */
(function () {
  'use strict';
  if (window.__VIBE_WHOLESALE_BOOTED__) return;
  window.__VIBE_WHOLESALE_BOOTED__ = true;
  
   console.info('[Wholesale] JS parsed');
window.addEventListener('error', function(e){
  console.error('[Wholesale runtime error]', e.message, e.filename, e.lineno, e.colno);
});

/* ---------- Spreadsheet config ---------- */
const SPREADSHEET_ID = "1E9GDRVlH9y6A_FU4fBQGQHJGmmZXUEigtMKrBdrS66o";
const API_KEY = "AIzaSyCjbE63xsbODAw8H9vfwteMaQAsDVZSdKU";
const RANGE = "Products!A:M";
const PAGE_SIZE = 50;

/* ---------- DOM helpers ---------- */
const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

/* ---------- Money helpers ---------- */
const toNumber = (s) => Number(String(s || "").replace(/[^0-9.\-]/g, "")) || 0;
const money = (n) => `$${(Number(n || 0)).toFixed(2)}`;

/* ---------- Original: fetch sheet ---------- */
async function fetchSheet() {
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${RANGE}?key=${API_KEY}`;
  const res = await fetch(url);
  const json = await res.json();
  const [header, ...rows] = json.values;
  return rows
    .map((row) => {
      const obj = {};
      header.forEach((col, i) => (obj[col] = row[i] || ""));
      return obj;
    })
    .filter((row) => row.Hide?.toLowerCase() !== "true");
}

/* ---------- Original: group by base SKU ---------- */
function groupByBaseSKU(rows) {
  const groups = {};
  for (const row of rows) {
    const sku = row["Variant SKU"];
    if (!sku) continue;
    const parts = sku.split("-");
    const base = parts.length > 1 ? parts.slice(0, -1).join("-") : sku;
    if (!groups[base]) groups[base] = [];
    groups[base].push(row);
  }
  return groups;
}

/* ---------- Normalizers reused by both UIs ---------- */
const metalCategory = (raw) => {
  const m = raw ? raw.toLowerCase() : "";
  if (m === "14k solid gold") return "14K Solid Gold";
  if (m.includes("oxidized") && m.includes("14k"))
    return "Oxidized Silver & 14K Gold";
  if (m === "oxidized sterling silver") return "Oxidized Sterling Silver";
  if (m.includes("silver") && m.includes("14k")) return "Silver & 14K Gold";
  if (m === "sterling silver") return "Sterling Silver";
  return raw;
};

const labelToSlug = (label) =>
  label
    .toLowerCase()
    .replace(/[\s\/&]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/^-+|-+$/g, "");

const getSwatchImageURL = (label) =>
  `https://vibejewelry.com/cdn/shop/files/${labelToSlug(label)}.png`;

function splitStones(raw) {
  return raw
    ? raw.replace(/[\[\]"]+/g, "").split(",").map((s) => s.trim()).filter(Boolean)
    : [];
}

/* ---------- Global-ish state ---------- */
let allGroups = {};
let currentEntries = [];
let pageLoaded = 0;
let allOpen = false;

/* qtyMap is the original cart model: { sku: qty } */
let qtyMap = loadQtyMap();

/* skuIndex lets us compute totals and show names from any SKU quickly */
const skuIndex = Object.create(null); // sku -> {title, size, retail, wholesale, base, stone, metal}

/* favorites flag */
let showOnlyFavorites = false;

/* ---------- DOM refs ---------- */
const catalog = $("#catalog");
const loadMoreBtn = $("#loadMoreBtn");

const ftContainer = $("#typeDropdown");
const typeBtn = $("#typeBtn");
const typePanel = $("#typePanel");

const fmContainer = $("#metalDropdown");
const metalBtn = $("#metalBtn");
const metalPanel = $("#metalPanel");

const fsContainer = $("#stoneDropdown");
const stoneBtn = $("#stoneBtn");
const stonePanel = $("#stonePanel");

const minPrice = $("#minPrice");
const maxPrice = $("#maxPrice");
const minWholesale = $("#minWholesale");
const maxWholesale = $("#maxWholesale");

const orderList = $("#orderList");
const toggleAllBtn = $("#toggleAllDetailsBtn");
const clearFiltersBtn = $("#clearFilters");
const downloadSidebar = $("#downloadCsvBtn");
const clearOrderBtn = $("#clearOrderBtn");
const viewBtn = $("#viewOrderBtn");

const sortBtn = $("#sortBtn");
const sortRadios = document.querySelectorAll('input[name="sort"]');
const sortPanel = $("#sortPanel");

/* ---------- Mobile drawers/sheet wiring (drop-in) ---------- */
const $id = (s, r = document) => r.querySelector(s);

const filterDrawer = $id("#filterDrawer");
const orderSheet   = $id("#orderSheet");

const openFiltersBtn = $id("#openFiltersBtn");
const openOrderBtn   = $id("#openOrderBtn");
const miniOpenOrder  = $id("#miniOpenOrder"); // sticky mini bar button

/* NEW: mobile toolbar buttons */
const mobileFavBtn      = $id("#mobileFavBtn");
const mobileToggleAllBtn= $id("#mobileToggleAllBtn");
const mobilePrintBtn    = $id("#mobilePrintBtn");

/* NEW: optional drawer footer buttons */
const drawerClearBtn = $id("#drawerClearBtn");  // put this inside drawer footer
const drawerApplyBtn = $id("#drawerApplyBtn");  // put this inside drawer footer

const mobileFilterMount = $id("#mobileFilterMount");
const mobileOrderMount  = $id("#mobileOrderMount");

const desktopFilterBarLeft = $id("#filterBar .bar-left"); // source of .filter-group nodes
const desktopOrderSidebar  = $id("#orderSidebar");

const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

/* ---- Move helpers (move, not clone, so handlers/IDs stay intact) ---- */
function moveFiltersToMobileIfNeeded() {
  if (!desktopFilterBarLeft || !mobileFilterMount) return;
  if (mobileFilterMount.querySelector(".filter-group")) return; // already hydrated
  desktopFilterBarLeft.querySelectorAll(".filter-group").forEach(el => {
    mobileFilterMount.appendChild(el);
  });
}
function moveFiltersBackToDesktop() {
  if (!desktopFilterBarLeft || !mobileFilterMount) return;
  mobileFilterMount.querySelectorAll(".filter-group").forEach(el => {
    desktopFilterBarLeft.appendChild(el);
  });
}
function moveOrderToMobileIfNeeded() {
  if (!desktopOrderSidebar || !mobileOrderMount) return;
  if (mobileOrderMount.childElementCount) return;
  const frag = document.createDocumentFragment();
  Array.from(desktopOrderSidebar.childNodes).forEach(n => frag.appendChild(n));
  mobileOrderMount.appendChild(frag);
}
function moveOrderBackToDesktop() {
  if (!desktopOrderSidebar || !mobileOrderMount) return;
  const frag = document.createDocumentFragment();
  Array.from(mobileOrderMount.childNodes).forEach(n => frag.appendChild(n));
  desktopOrderSidebar.appendChild(frag);
}

/* ---- Open/close helpers ---- */
function openFilterDrawer()  { filterDrawer?.setAttribute("aria-hidden", "false"); }
function closeFilterDrawer() { filterDrawer?.setAttribute("aria-hidden", "true"); }
function openOrderSheet()    { orderSheet?.setAttribute("aria-hidden", "false"); }
function closeOrderSheet()   { orderSheet?.setAttribute("aria-hidden", "true"); }

/* ---- Hydration for current breakpoint ---- */
function hydrateMobileLayout() {
  if (isMobile()) {
    moveFiltersToMobileIfNeeded();
    moveOrderToMobileIfNeeded();
  } else {
    moveFiltersBackToDesktop();
    moveOrderBackToDesktop();
    closeFilterDrawer();
    closeOrderSheet();
  }
}

/* ---- Event wiring: openers ---- */
openFiltersBtn?.addEventListener("click", () => { moveFiltersToMobileIfNeeded(); openFilterDrawer(); });
openOrderBtn?.addEventListener("click",   () => { moveOrderToMobileIfNeeded();  openOrderSheet();   });
miniOpenOrder?.addEventListener("click",  () => { moveOrderToMobileIfNeeded();  openOrderSheet();   });

/* ---- NEW: Mobile toolbar actions ---- */
function syncFavoritesButtons() {
  const text = showOnlyFavorites ? "Show All Products" : "Show Favorites Only";
  document.querySelector("#toggleFavoritesBtn") && (document.querySelector("#toggleFavoritesBtn").textContent = text);
  mobileFavBtn && (mobileFavBtn.textContent = text);
}
mobileFavBtn?.addEventListener("click", () => {
  showOnlyFavorites = !showOnlyFavorites;
  syncFavoritesButtons();
  applyFilters();
});

function toggleAllVariants() {
  allOpen = !allOpen;
  document.querySelectorAll(".card").forEach((c) => {
    const det = c.querySelector(".details-wrapper");
    const tog = c.querySelector(".toggle-details");
    if (!det || !tog) return;
    if (allOpen) {
      det.classList.remove("m:hidden");
      tog.style.display = "none";
    } else {
      det.classList.add("m:hidden");
      tog.style.display = "inline-block";
      tog.textContent = "Show Variants";
    }
  });
  const txt = allOpen ? "Hide All Variants" : "Show All Variants";
  document.querySelector("#toggleAllDetailsBtn") && (document.querySelector("#toggleAllDetailsBtn").textContent = txt);
  mobileToggleAllBtn && (mobileToggleAllBtn.textContent = txt);
}
mobileToggleAllBtn?.addEventListener("click", toggleAllVariants);

/* Reuse existing print handler if present */
mobilePrintBtn?.addEventListener("click", () => {
  const printBtn = document.getElementById("printPdfBtn");
  if (printBtn) printBtn.click();
});

/* ---- NEW: Drawer footer buttons ---- */
/* Give your buttons these IDs in the drawer footer:
   <button id="drawerClearBtn" class="chip action-warning">Clear Filters</button>
   <button id="drawerApplyBtn" class="chip action-primary">Apply</button>
*/
drawerClearBtn?.addEventListener("click", () => {
  // trigger the same logic as desktop Clear Filters
  const clear = document.getElementById("clearFilters");
  if (clear) { clear.click(); }
});
drawerApplyBtn?.addEventListener("click", () => {
  // filters auto-apply on change; Apply just closes the drawer
  closeFilterDrawer();
});

/* ---- Backdrops/close buttons ---- */
document.querySelectorAll("[data-close-drawer]").forEach(b => b.addEventListener("click", closeFilterDrawer));
document.querySelectorAll("[data-close-sheet]").forEach(b => b.addEventListener("click", closeOrderSheet));

/* ---- ESC to close either ---- */
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") { closeFilterDrawer(); closeOrderSheet(); }
});

/* ---- Keep layout in sync on resize (debounced) ---- */
window.addEventListener("resize", () => {
  clearTimeout(window.__mobRsz);
  window.__mobRsz = setTimeout(hydrateMobileLayout, 150);
});

/* Ensure drawers hidden initially to avoid SSR flash */
filterDrawer?.setAttribute("aria-hidden", "true");
orderSheet?.setAttribute("aria-hidden", "true");

/* Initial boot */
hydrateMobileLayout();
/* Keep button labels correct on first paint */
syncFavoritesButtons();
(() => {
  const txt = allOpen ? "Hide All Variants" : "Show All Variants";
  const d = document.querySelector("#toggleAllDetailsBtn");
  if (d) d.textContent = txt;
  if (mobileToggleAllBtn) mobileToggleAllBtn.textContent = txt;
})();


/* ---------- Filter UI util ---------- */
function updateLabel(btn, container) {
  if (!container) return;

  const checkboxes = container.querySelectorAll('input[type="checkbox"]:checked');
  const activeValues = container.querySelector(".filter-group__values-active-values");
  const clearBtn = container.querySelector("[data-filter-group-reset]");
  const selected = Array.from(checkboxes).map((cb) => cb.value);
  const count = selected.length;

  let countEl = btn.querySelector("[data-group-active-count]");
  if (countEl) {
    countEl.textContent = count > 0 ? count : "";
    countEl.classList.toggle("m:hidden", count === 0);
  }

  if (activeValues) {
    activeValues.textContent = count > 0 ? selected.join(", ") : "0 selected";
  }

  if (clearBtn) {
    clearBtn.classList.toggle("m:hidden", count === 0);
  }
}

/* ---------- Active facets (chips) under toolbar ---------- */
const activeFacetsBar = document.getElementById("activeFacets");

function getActiveFacetData() {
  // Checkbox facets
  const types  = typeSelected();
  const metals = metalSelected();
  const stones = stoneSelected();

  // Price facets
  const [minP, maxP] = parsePriceRange(minPrice, maxPrice);
  const [minW, maxW] = parsePriceRange(minWholesale, maxWholesale);

  const priceParts = [];
  if (minP !== null || maxP !== null) {
    const a = (minP !== null) ? `$${minP.toFixed(0)}` : "";
    const b = (maxP !== null) ? `$${maxP.toFixed(0)}` : "∞";
    priceParts.push({ key: "Retail", label: `Retail ${a || "0"}–${b}` });
  }
  if (minW !== null || maxW !== null) {
    const a = (minW !== null) ? `$${minW.toFixed(0)}` : "";
    const b = (maxW !== null) ? `$${maxW.toFixed(0)}` : "∞";
    priceParts.push({ key: "Wholesale", label: `Wholesale ${a || "0"}–${b}` });
  }

  return {
    types,
    metals,
    stones,
    priceParts
  };
}

function rebuildActiveFacets() {
  if (!activeFacetsBar) return;
  activeFacetsBar.innerHTML = "";

  const { types, metals, stones, priceParts } = getActiveFacetData();
  const any =
    types.length || metals.length || stones.length || priceParts.length;

  // helper to make a chip
  const chip = (text, kind, onRemove) => {
    const el = document.createElement("span");
    el.className = `facet-chip facet-chip--${kind}`;
    el.innerHTML = `${text} <button type="button" class="facet-remove" aria-label="Remove filter">×</button>`;
    el.querySelector(".facet-remove").addEventListener("click", onRemove);
    activeFacetsBar.appendChild(el);
  };

  // TYPE chips
  types.forEach(val => {
    chip(val, "type", () => {
      // uncheck checkbox with this value
      const input = Array.from(
        document.querySelectorAll('#typeDropdown input[type="checkbox"]')
      ).find(i => i.value === val);
      if (input) input.checked = false;
      updateTypeBtnLabel();
      debounced();
    });
  });

  // METAL chips
  metals.forEach(val => {
    chip(val, "metal", () => {
      const input = Array.from(
        document.querySelectorAll('#metalDropdown input[type="checkbox"]')
      ).find(i => i.value === val);
      if (input) input.checked = false;
      updateMetalBtnLabel();
      debounced();
    });
  });

  // STONE chips
  stones.forEach(val => {
    chip(val, "stone", () => {
      const input = Array.from(
        document.querySelectorAll('#stoneDropdown input[type="checkbox"]')
      ).find(i => i.value === val);
      if (input) input.checked = false;
      updateStoneBtnLabel();
      debounced();
    });
  });

  // PRICE chips (retail + wholesale)
  priceParts.forEach(p => {
    chip(p.label, "price", () => {
      // clear corresponding price range
      if (p.key === "Retail") {
        if (minPrice) minPrice.value = "";
        if (maxPrice) maxPrice.value = "";
      } else {
        if (minWholesale) minWholesale.value = "";
        if (maxWholesale) maxWholesale.value = "";
      }
      updatePriceBtnLabel();
      debounced();
    });
  });

  if (any) {
    const clearAll = document.createElement("button");
    clearAll.className = "clear-all";
    clearAll.type = "button";
    clearAll.textContent = "Clear all";
    clearAll.addEventListener("click", () => {
      // reuse existing logic
      document.getElementById("clearFilters")?.click();
    });
    activeFacetsBar.appendChild(clearAll);
  }
}

/* Call this whenever filters change */
function onFiltersChanged() {
  rebuildActiveFacets();
}


function initFilterGroups() {
  const groups = document.querySelectorAll("[data-filter-group]");

  function closeAll() {
    groups.forEach((group) => {
      const btn = group.querySelector("[data-dropdown-toggle]");
      const panel = document.getElementById(btn?.getAttribute("aria-controls"));
      if (btn && panel) {
        btn.setAttribute("aria-expanded", "false");
        panel.setAttribute("aria-hidden", "true");
        panel.classList.add("m:hidden");
        group.classList.remove("filter-group--active");
      }
    });
  }

  groups.forEach((group) => {
    const container = group.querySelector("[data-filter-group-values]");
    const btn = group.querySelector("[data-dropdown-toggle]");
    if (!btn || !container) return;

    container.addEventListener("change", () => {
      updateLabel(btn, container);
      debounced();
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });
}

function debounce(fn, ms) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), ms);
  };
}
const debounced = debounce(() => {
  updateFilterOptions();
  applyFilters();
  renderOrder(); // also updates mini totals
   rebuildActiveFacets();
}, 300);

const metalCheckboxes = () =>
  fmContainer.querySelectorAll('input[type="checkbox"]:checked');
const stoneCheckboxes = () =>
  fsContainer.querySelectorAll('input[type="checkbox"]:checked');
const typeCheckboxes = () =>
  ftContainer.querySelectorAll('input[type="checkbox"]:checked');

function metalSelected() {
  return Array.from(metalCheckboxes()).map((cb) => cb.value);
}
function stoneSelected() {
  return Array.from(stoneCheckboxes()).map((cb) => cb.value);
}
function typeSelected() {
  return Array.from(typeCheckboxes()).map((cb) => cb.value);
}

/* ---------- Sorting ---------- */
function closeSortPanel() {
  if (!sortBtn || !sortPanel) return;
  sortBtn.setAttribute("aria-expanded", "false");
  sortPanel.setAttribute("aria-hidden", "true");
  sortPanel.classList.add("m:hidden");
  // If your sort lives inside a [data-filter-group], clear its active class:
  const sortDropdown = sortBtn.closest("[data-filter-group]");
  sortDropdown && sortDropdown.classList.remove("filter-group--active");
}

sortRadios.forEach((radio) => {
  radio.addEventListener("change", () => {
    if (!radio.checked) return;

    const sortLabel = sortBtn?.querySelector(".sort-label");
    if (sortLabel) {
      const lbl = radio.closest("label")?.textContent?.trim() || "Default";
      sortLabel.textContent = `Sort: ${lbl}`;
    }

    document.querySelectorAll("#filterSortContainer li").forEach((li) =>
      li.classList.remove("is-selected")
    );
    radio.closest("li")?.classList.add("is-selected");

    applyFilters();
    closeSortPanel();
  });
});


/* ---------- Price controls ---------- */
function parsePriceRange(minEl, maxEl) {
  const min = parseFloat(minEl?.value);
  const max = parseFloat(maxEl?.value);
  return [isNaN(min) ? null : min, isNaN(max) ? null : max];
}

function updateTypeBtnLabel() {
  updateLabel(typeBtn, typePanel?.querySelector("[data-filter-group-values]"));
}
function updateMetalBtnLabel() {
  updateLabel(metalBtn, metalPanel?.querySelector("[data-filter-group-values]"));
}
function updateStoneBtnLabel() {
  updateLabel(stoneBtn, stonePanel?.querySelector("[data-filter-group-values]"));
}
function updatePriceBtnLabel() {
  const activeValues = document.querySelector("#pricePanel .filter-group__values-active-values");
  const clearBtn = document.querySelector('[data-filter-group-reset="Price"]');
  const countBadge = document.querySelector('[data-filter-group="Price"] [data-group-active-count]');

  if (!minPrice || !maxPrice || !minWholesale || !maxWholesale || !activeValues) return;

  const [minP, maxP] = parsePriceRange(minPrice, maxPrice);
  const [minW, maxW] = parsePriceRange(minWholesale, maxWholesale);

  const hasMin = minP !== null;
  const hasMax = maxP !== null;
  const hasMinW = minW !== null;
  const hasMaxW = maxW !== null;

  const formattedMin = hasMin ? `$${minP.toFixed(0)}` : "";
  const formattedMax = hasMax ? `$${maxP.toFixed(0)}` : "";
  const formattedMinW = hasMinW ? `$${minW.toFixed(0)}` : "";
  const formattedMaxW = hasMaxW ? `$${maxW.toFixed(0)}` : "";

  const retailRange =
    hasMin && hasMax ? `${formattedMin} – ${formattedMax}` :
    hasMin ? `From ${formattedMin}` :
    hasMax ? `Up to ${formattedMax}` : "";

  const wholesaleRange =
    hasMinW && hasMaxW ? `${formattedMinW} – ${formattedMaxW}` :
    hasMinW ? `From ${formattedMinW}` :
    hasMaxW ? `Up to ${formattedMaxW}` : "";

  const parts = [];
  if (retailRange) parts.push(`Retail: ${retailRange}`);
  if (wholesaleRange) parts.push(`Wholesale: ${wholesaleRange}`);

  activeValues.textContent = parts.length ? parts.join(" | ") : "No price range set";

  if (clearBtn) clearBtn.classList.toggle("m:hidden", parts.length === 0);
  if (countBadge) {
    const count = [hasMin, hasMax, hasMinW, hasMaxW].filter(Boolean).length;
    countBadge.textContent = count > 0 ? count : "";
    countBadge.classList.toggle("m:hidden", count === 0);
  }
}

[minPrice, maxPrice, minWholesale, maxWholesale].forEach(
  (e) =>
    (e && (e.oninput = () => {
      updatePriceBtnLabel();
      debounced();
    }))
);

document
  .querySelector('[data-filter-group-reset="Price"]')
  ?.addEventListener("click", () => {
    if (minPrice) minPrice.value = "";
    if (maxPrice) maxPrice.value = "";
    if (minWholesale) minWholesale.value = "";
    if (maxWholesale) maxWholesale.value = "";
    updatePriceBtnLabel();
    applyFilters();
  });

/* ---------- Build filter chips ---------- */
function createFacetCheckbox(idPrefix, value, index, isChecked, withSwatch = false) {
  const li = document.createElement("li");
  li.className = "m-facet--item";

  const label = document.createElement("label");
  label.className = "m-facet--checkbox";
  label.setAttribute("for", `${idPrefix}-${index}`);

  const input = document.createElement("input");
  input.type = "checkbox";
  input.id = `${idPrefix}-${index}`;
  input.value = value;
  if (isChecked) input.checked = true;

  const span = document.createElement("span");
  span.className = "m-facet--label";
  const swatch = withSwatch
    ? `<span class="facet-swatch" style="background-image:url('${getSwatchImageURL(value)}')"></span>`
    : "";
  span.innerHTML = `${swatch}${value}`;

  label.append(input, span);
  li.append(label);
  return li;
}

function sortStones(stones) {
  return stones.sort((a, b) => {
    if (a === "No Stone") return -1;
    if (b === "No Stone") return 1;
    return a.localeCompare(b);
  });
}

function populateTypeCheckboxes(types) {
  const prev = typeSelected();
  const container = document.getElementById("filterTypeContainer");
  if (!container) return;
  container.innerHTML = "";
  types.forEach((type, i) => {
    container.appendChild(createFacetCheckbox("Filter-Type", type, i, prev.includes(type)));
  });
  updateTypeBtnLabel();
}

function populateMetalCheckboxes(metals) {
  const prev = metalSelected();
  const container = document.getElementById("filterMetalContainer");
  if (!container) return;
  container.innerHTML = "";
  metals.forEach((metal, i) => {
    const category = metalCategory(metal);
    container.appendChild(
      createFacetCheckbox("Filter-Metal", category, i, prev.includes(category), true)
    );
  });
  updateMetalBtnLabel();
}

function populateStoneCheckboxes(stones) {
  const prev = stoneSelected();
  const container = document.getElementById("filterStoneContainer");
  if (!container) return;
  container.innerHTML = "";
  stones.forEach((stone, i) => {
    container.appendChild(
      createFacetCheckbox("Filter-Stone", stone, i, prev.includes(stone), true)
    );
  });
  updateStoneBtnLabel();
}

function populateFilters() {
  const Ts = new Set(),
        Ms = new Set(),
        Ss = new Set();
  Object.values(allGroups)
    .flat()
    .forEach((r) => {
      Ts.add(r.Type);
      Ms.add(metalCategory(r.Metal));
      splitStones(r.Stone).forEach((s) => Ss.add(s));
    });
  populateTypeCheckboxes([...Ts].sort());
  populateMetalCheckboxes([...Ms].sort());
  const sortedStones = sortStones([...Ss]);
  populateStoneCheckboxes(sortedStones);
}

function updateFilterOptions() {
  const tVals = typeSelected();
  const mVals = metalSelected();
  const sVals = stoneSelected();
  const curMin = parseFloat(minPrice?.value);
  const curMax = parseFloat(maxPrice?.value);
  const nonPrice = Object.values(allGroups).filter((vs) => {
    if (tVals.length && !tVals.includes(vs[0].Type)) return false;
    if (mVals.length && !mVals.includes(metalCategory(vs[0].Metal))) return false;
    if (sVals.length && !splitStones(vs[0].Stone).some((x) => sVals.includes(x))) return false;
    return true;
  });
  const allPrices = nonPrice.flatMap((vs) =>
    vs.map((v) => parseFloat(v["Variant Price"] || v.SRP) || 0)
  );
  const domainMin = allPrices.length ? Math.min(...allPrices) : 0;
  const domainMax = allPrices.length ? Math.max(...allPrices) : 0;
  const minValid = !isNaN(curMin);
  const maxValid = !isNaN(curMax) && curMax >= domainMin && curMax <= domainMax;
  maxPrice && maxPrice.classList.toggle("invalid", !maxValid && !isNaN(curMax));
  const priceOk = (vs) =>
    vs.some((v) => {
      const p = parseFloat(v["Variant Price"] || v.SRP) || 0;
      if (minValid && p < curMin) return false;
      if (maxValid && p > curMax) return false;
      return true;
    });
  const Ts = new Set(),
        Ms = new Set(),
        Ss = new Set();
  Object.values(allGroups).forEach((vs) => {
    if ((!mVals.length || mVals.includes(metalCategory(vs[0].Metal))) &&
        (!sVals.length || splitStones(vs[0].Stone).some((x) => sVals.includes(x))) &&
        priceOk(vs)) Ts.add(vs[0].Type);
    if ((!tVals.length || tVals.includes(vs[0].Type)) &&
        (!sVals.length || splitStones(vs[0].Stone).some((x) => sVals.includes(x))) &&
        priceOk(vs)) Ms.add(metalCategory(vs[0].Metal));
    if ((!tVals.length || tVals.includes(vs[0].Type)) &&
        (!mVals.length || mVals.includes(metalCategory(vs[0].Metal))) &&
        priceOk(vs)) splitStones(vs[0].Stone).forEach((s) => Ss.add(s));
  });
  populateTypeCheckboxes([...Ts].sort());
  populateMetalCheckboxes([...Ms].sort());
  const sortedStones = sortStones([...Ss]);
  populateStoneCheckboxes(sortedStones);
}

/* ---------- Original: CARD RENDERER (kept as-is) ---------- */
function makeCard(vs) {
  const f = vs[0];
  const handle = f.Handle || ""; 
  const title = f.Title.includes("-")
    ? f.Title.slice(0, f.Title.lastIndexOf("-")).trim()
    : f.Title;
  const prices = vs.map((v) => parseFloat(v["Variant Price"] || v.SRP) || 0);
  const minR = Math.min(...prices).toFixed(0);
  const maxR = Math.max(...prices).toFixed(0);
  const priceDisplay = minR === maxR ? `$${minR}` : `$${minR} - $${maxR}`;
  const showSize = vs.length > 1;
  const ths = [
    showSize ? "<th>Size</th>" : "",
    "<th>SRP</th>",
    "<th>Wholesale</th>",
    "<th>SKU</th>",
    "<th>Qty</th>",
  ]
    .filter(Boolean)
    .join("");
  const rows = vs
    .map((v) => {
      const sku = v["Variant SKU"];
      const size = sku.split("-").pop();
      const rp = (parseFloat(v["Variant Price"] || v.SRP) || 0).toFixed(0);
      const wp = (parseFloat(v["Wholesale Price"]) || 0).toFixed(0);
      const q = qtyMap[sku] || 0;
      return `<tr>${
        showSize ? `<td>${size}</td>` : ""
      }<td>$${rp}</td><td>$${wp}</td><td>${sku}</td><td><input type="number" data-sku="${sku}" min="0" step="1" value="${q}"></td></tr>`;
    })
    .join("");
  const baseSku =
    vs[0]["Variant SKU"].split("-").slice(0, -1).join("-") ||
    vs[0]["Variant SKU"];

  const imgHtml = f["Image URL"]
    ? `<div class="image-wrapper">
       <img src="${f["Image URL"]}" alt="${title}" loading="lazy">
       <button class="favorite-toggle" data-sku="${baseSku}" aria-label="Toggle favorite">
         <span class="star" aria-hidden="true"></span>
       </button>
     </div>`
    : `<div class="image-wrapper no-image">
       No image available
       <button class="favorite-toggle" data-sku="${baseSku}" aria-label="Toggle favorite">
         <span class="star" aria-hidden="true"></span>
       </button>
     </div>`;

  return `<div class="card" data-type="${f.Type || ''}" data-metal="${metalCategory(f.Metal) || ''}" data-stone="${f.Stone || ''}">
  ${imgHtml}
  <h3><a href="https://vibejewelry.com/products/${handle}" target="_blank" rel="noopener noreferrer">${title}</a></h3>
  <div class="meta">Metal: ${metalCategory(f.Metal)}</div>
  <div class="meta">Stone: ${f.Stone}</div>
  <div class="meta price">Price: ${priceDisplay}</div>
  <button class="toggle-details">Show Variants</button>
  <div class="details-wrapper m:hidden">
    <table>
      <thead><tr>${ths}</tr></thead>
      <tbody>${rows}</tbody>
    </table>
  </div>
</div>`;
}

/* ---------- Intersection rendering (original behavior) ---------- */
const observer = new IntersectionObserver(
  (entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const idx = +entry.target.dataset.idx;
      const wrapper = document.createElement("div");
      wrapper.innerHTML = makeCard(currentEntries[idx]);
      const card = wrapper.firstElementChild;
      entry.target.replaceWith(card);
      obs.unobserve(entry.target);
      updateFavoriteUI();

      // sync qty inputs -> qtyMap
      card.querySelectorAll("input[data-sku]").forEach((i) => {
        i.oninput = () => {
          qtyMap[i.dataset.sku] = +i.value || 0;
          saveQtyMap();
          renderOrder(); // also updates mini totals
        };
      });

      // toggle details button
      const tog = card.querySelector(".toggle-details");
      const det = card.querySelector(".details-wrapper");
      if (tog && det) {
        tog.onclick = () => {
          const hidden = det.classList.toggle("m:hidden");
          tog.textContent = hidden ? "Show Variants" : "Hide Variants";
        };
        if (allOpen) {
          det.classList.remove("m:hidden");
          tog.style.display = "none";
        }
      }
      // click any non-Qty cell to +1 that row's qty
const tbody = card.querySelector(".details-wrapper tbody");
if (tbody) {
  tbody.addEventListener("click", (e) => {
    const td = e.target.closest("td");
    if (!td) return;

    // ignore clicks inside the Qty cell or on the input itself
    const row = td.parentElement;
    const cells = Array.from(row.children);
    const qtyCell = cells[cells.length - 1];
    if (td === qtyCell || e.target.closest('input[type="number"]')) return;

    const input = row.querySelector('input[data-sku]');
    if (!input) return;

    const next = (parseInt(input.value, 10) || 0) + 1;
    input.value = String(next);

    // trigger existing oninput sync (qtyMap + mini totals + order list)
    input.dispatchEvent(new Event("input", { bubbles: true }));
  });
}

    });
  },
  { root: null, rootMargin: "0px 0px 200px 0px", threshold: 0 }
);

function loadNextPage() {
  const start = pageLoaded * PAGE_SIZE;
  const end = Math.min(currentEntries.length, start + PAGE_SIZE);
  if (start >= end) {
    loadMoreBtn && (loadMoreBtn.style.display = "none");
    return;
  }
  const frag = document.createDocumentFragment();
  for (let i = start; i < end; i++) {
    const ph = document.createElement("div");
    ph.className = "card placeholder";
    ph.dataset.idx = i;
    frag.appendChild(ph);
    observer.observe(ph);
  }
  catalog.appendChild(frag);
  pageLoaded++;
  if (loadMoreBtn) {
    loadMoreBtn.style.display = pageLoaded * PAGE_SIZE < currentEntries.length ? "block" : "none";
  }
  updateFavoriteUI();
}

function syncSortLabel() {
  const selected = document.querySelector('input[name="sort"]:checked');
  const label = selected?.closest("label")?.textContent?.trim();
  const lbl = sortBtn?.querySelector(".sort-label");
  if (lbl && label) lbl.textContent = `Sort: ${label}`;
}

/* ---------- Favorites ---------- */
function getFavorites() {
  return JSON.parse(localStorage.getItem("vibe_favorites") || "[]");
}
function saveFavorites(favs) {
  localStorage.setItem("vibe_favorites", JSON.stringify(favs));
}
function toggleFavorite(sku) {
  let favs = getFavorites();
  if (favs.includes(sku)) {
    favs = favs.filter((s) => s !== sku);
  } else {
    favs.push(sku);
  }
  saveFavorites(favs);
  updateFavoriteUI();
}
function updateFavoriteUI() {
  const favs = getFavorites();
  document.querySelectorAll(".favorite-toggle").forEach((btn) => {
    const sku = btn.dataset.sku;
    btn.classList.toggle("active", favs.includes(sku));
  });
}

$("#toggleFavoritesBtn")?.addEventListener("click", () => {
  showOnlyFavorites = !showOnlyFavorites;
  $("#toggleFavoritesBtn").textContent = showOnlyFavorites
    ? "Show All Products"
    : "Show Favorites Only";
  applyFilters();
});

/* ---------- Filters apply (original + mini merge) ---------- */
function applyFilters() {
  const tVals = typeSelected();
  const mVals = metalSelected();
  const sVals = stoneSelected();

  const [minP, maxP] = parsePriceRange(minPrice, maxPrice);
  const [minW, maxW] = parsePriceRange(minWholesale, maxWholesale);

  const minRetail = minP ?? 0;
  const maxRetail = maxP ?? Infinity;
  const minWholesalePrice = minW ?? 0;
  const maxWholesalePrice = maxW ?? Infinity;

  const favSet = new Set(showOnlyFavorites ? getFavorites() : []);
  let raw = Object.entries(allGroups)
    .filter(([base, vs]) => {
      if (showOnlyFavorites && !favSet.has(base)) return false;
      if (tVals.length && !tVals.includes(vs[0].Type)) return false;
      if (mVals.length && !mVals.includes(metalCategory(vs[0].Metal))) return false;
      if (sVals.length && !splitStones(vs[0].Stone).some((s) => sVals.includes(s))) return false;
      if (
        !vs.some((v) => {
          const retail = toNumber(v["Variant Price"] || v.SRP);
          const wholesale = toNumber(v["Wholesale Price"]);
          return (
            retail >= minRetail &&
            retail <= maxRetail &&
            wholesale >= minWholesalePrice &&
            wholesale <= maxWholesalePrice
          );
        })
      ) return false;
      return true;
    })
    .map(([, vs]) => vs);

  const sortVal = document.querySelector('input[name="sort"]:checked')?.value || "default";
  switch (sortVal) {
    case "title-asc":
      raw.sort((a, b) => a[0].Title.localeCompare(b[0].Title));
      break;
    case "title-desc":
      raw.sort((a, b) => b[0].Title.localeCompare(a[0].Title));
      break;
    case "price-asc":
      raw.sort((a, b) => {
        const aPrice = Math.min(...a.map((v) => toNumber(v["Variant Price"] || v.SRP)));
        const bPrice = Math.min(...b.map((v) => toNumber(v["Variant Price"] || v.SRP)));
        return aPrice - bPrice;
      });
      break;
    case "price-desc":
      raw.sort((a, b) => {
        const aPrice = Math.max(...a.map((v) => toNumber(v["Variant Price"] || v.SRP)));
        const bPrice = Math.max(...b.map((v) => toNumber(v["Variant Price"] || v.SRP)));
        return bPrice - aPrice;
      });
      break;
    case "default":
    default:
      break;
  }

  currentEntries = raw;
  pageLoaded = 0;
  catalog.innerHTML = "";

  if (!currentEntries.length) {
    if (loadMoreBtn) loadMoreBtn.style.display = "none";
    catalog.innerHTML = '<div class="no-products">No products found</div>';
    return;
  }
  syncSortLabel();
  loadNextPage();
  updateFavoriteUI();
}

/* ---------- Order list + Mini totals ---------- */
function computeTotals() {
  let qty = 0, wholesale = 0, retail = 0;
  Object.entries(qtyMap).forEach(([sku, q]) => {
    q = Number(q) || 0;
    if (q <= 0) return;
    const meta = skuIndex[sku];
    if (!meta) return;
    qty += q;
    wholesale += (meta.wholesale || 0) * q;
    retail += (meta.retail || 0) * q;
  });
  return { qty, wholesale, retail };
}

function renderMiniTotals() {
  const { qty, wholesale, retail } = computeTotals();
  $("#miniCount") && ($("#miniCount").textContent = `${qty} ${qty === 1 ? "item" : "items"}`);
  $("#miniWholesale") && ($("#miniWholesale").textContent = money(wholesale));
  $("#miniRetail") && ($("#miniRetail").textContent = money(retail));

  $("#sumItems") && ($("#sumItems").textContent = qty);
  $("#sumWholesale") && ($("#sumWholesale").textContent = money(wholesale));
  $("#sumRetail") && ($("#sumRetail").textContent = money(retail));
}

/* Keep original renderOrder, but enhance presentation and 2-way sync */
function renderOrder() {
  if (!orderList) return;
  orderList.innerHTML = "";
  const entries = Object.entries(qtyMap).filter(([, q]) => Number(q) > 0);

  entries.forEach(([sku, q]) => {
    const li = document.createElement("li");
    li.className = "order-line";

    const meta = skuIndex[sku] || {};
    const name = meta.title || sku;
    const size = meta.size || "";
    const wholesale = meta.wholesale || 0;
    const retail = meta.retail || 0;

    li.innerHTML = `
      <div>
        <div><strong>${name}</strong></div>
        <div class="order-line__meta">SKU: ${sku}${size ? ` • Size: ${size}` : ""} • W: ${money(wholesale)} • MSRP: ${money(retail)}</div>
      </div>
      <div class="order-line__qty">
        <label class="sr" for="qty-${sku}">Qty</label>
        <input id="qty-${sku}" type="number" min="0" step="1" value="${q}" data-order-sku="${sku}">
        <button class="order-line__remove" data-remove-sku="${sku}">Remove</button>
      </div>
    `;
    orderList.appendChild(li);
  });

  // persist + update totals
  saveQtyMap();
  renderMiniTotals();
}

/* 2-way sync between order summary inputs and catalog table inputs */
document.addEventListener("input", (e) => {
  const sku = e.target?.getAttribute?.("data-order-sku");
  if (!sku) return;
  const qty = Number(e.target.value) || 0;
  qtyMap[sku] = qty;

  // reflect into table
  const tableInput = document.querySelector(`input[data-sku="${CSS.escape(sku)}"]`);
  if (tableInput) tableInput.value = qty;

  renderOrder();
});
document.addEventListener("click", (e) => {
  const sku = e.target?.getAttribute?.("data-remove-sku");
  if (!sku) return;
  qtyMap[sku] = 0;
  const tableInput = document.querySelector(`input[data-sku="${CSS.escape(sku)}"]`);
  if (tableInput) tableInput.value = 0;
  renderOrder();
});

/* ---------- Clear filters ---------- */
clearFiltersBtn && (clearFiltersBtn.onclick = () => {
  if (minPrice) minPrice.value = "";
  if (maxPrice) maxPrice.value = "";
  if (minWholesale) minWholesale.value = "";
  if (maxWholesale) maxWholesale.value = "";

  const groups = document.querySelectorAll("[data-filter-group]");
  groups.forEach((group) => {
    const container = group.querySelector("[data-filter-group-values]");
    container?.querySelectorAll('input[type="checkbox"]').forEach((cb) => (cb.checked = false));
    const btn = group.querySelector("[data-dropdown-toggle]");
    updateLabel(btn, container);
  });

  updatePriceBtnLabel();
  updateFilterOptions();
  applyFilters();
  renderOrder();
  rebuildActiveFacets();
});

/* ---------- Export CSV (sidebar + mini) ---------- */
function buildCsvSimple() {
  const rows = ["SKU,Quantity"];
  Object.entries(qtyMap).forEach(([s, q]) => Number(q) > 0 && rows.push(`${s},${q}`));
  return rows.join("\n");
}
function downloadCsv(filename = "purchase_order.csv") {
  const csv = buildCsvSimple();
  if (!csv || csv.trim() === "SKU,Quantity") return alert("No quantities");
  const blob = new Blob([csv], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
}
downloadSidebar && (downloadSidebar.onclick = () => downloadCsv());
$("#miniExportCsv") && ($("#miniExportCsv").onclick = () => downloadCsv());

/* ---------- Clear order ---------- */
clearOrderBtn && (clearOrderBtn.onclick = () => {
  if (!Object.values(qtyMap).some((q) => q > 0)) return alert("Order empty");
  if (confirm("Clear order?")) {
    qtyMap = {};
    saveQtyMap();
    document.querySelectorAll("input[data-sku]").forEach((i) => (i.value = 0));
    renderOrder();
  }
});

/* ---------- Toggle all variants ---------- */
if (toggleAllBtn) {
  toggleAllBtn.textContent = "Show All Variants";
  toggleAllBtn.onclick = () => {
    allOpen = !allOpen;
    document.querySelectorAll(".card").forEach((c) => {
      const det = c.querySelector(".details-wrapper"),
        tog = c.querySelector(".toggle-details");
      if (!det || !tog) return;
      if (allOpen) {
        det.classList.remove("m:hidden");
        tog.style.display = "none";
      } else {
        det.classList.add("m:hidden");
        tog.style.display = "inline-block";
        tog.textContent = "Show Variants";
      }
    });
    toggleAllBtn.textContent = allOpen ? "Hide All Variants" : "Show All Variants";
  };
}

/* ---------- Slide-in sidebar on mobile ---------- */
viewBtn && (viewBtn.onclick = () => {
  const sidebar = $("#orderSidebar");
  if (!sidebar) return;
  const open = sidebar.classList.toggle("open");
  viewBtn.textContent = open ? "Hide Order Summary" : "View Order Summary";
});

/* ---------- Load more ---------- */
loadMoreBtn && (loadMoreBtn.onclick = loadNextPage);

/* ---------- Print / PDF Export (unchanged behavior) ---------- */
var printBtn = document.getElementById("printPdfBtn");
if (printBtn) {
  printBtn.addEventListener("click", async function () {
    const cards = Array.from(document.querySelectorAll("#catalog .card"));
    const headStyles = document.head.innerHTML;

    // Clone cards and replace <img> with base64 to ensure images embed
    const preloadImageAsBase64 = async (img) => {
      return new Promise((res) => {
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.src = img.src;
        image.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = image.naturalWidth;
            canvas.height = image.naturalHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0);
            res(canvas.toDataURL("image/png"));
          } catch (e) {
            res(img.src); // fallback
          }
        };
        image.onerror = () => res(img.src);
      });
    };

    for (const card of cards) {
      const imgs = card.querySelectorAll("img");
      for (const img of imgs) {
        const base64 = await preloadImageAsBase64(img);
        img.setAttribute("src", base64);
      }
    }

    const cardsHtml = cards.map((c) => c.outerHTML).join("");

    const printWindow = window.open("", "_blank", "width=800,height=600");

    printWindow.document.write(`<!DOCTYPE html>
<html>
  <head>
    <title>Catalog Export</title>
    ${headStyles}
<style>
  body { font-size: 10px; margin: 0.5cm; }
  #print-catalog { display: grid; grid-template-columns: repeat(4, 1fr); gap: 0.5rem; }
  .card { box-sizing: border-box; display: flex; flex-direction: column; page-break-inside: avoid; margin-bottom: 1rem; border: 1px solid #dddddd; padding: 0.4rem; }
  .card h3, .card p { margin: 0 0 0.3em; font-size: 1em; }
  .details-wrapper { display: block !important; margin-top: 0.5em;word-break: break-word;  }
  .card table { width: 100%; border-collapse: collapse; font-size: 0.75em; table-layout: fixed; }
  .card th, .card td { border: 1px solid #dddddd; padding: 0.2em; text-align: center; word-break: break-word; }
  .card input[type="number"] { width: 100%; box-sizing: border-box; font-size: 0.75em; padding: 0.1em; text-align: center; }
  .toggle-details, .favorite-toggle { display: none !important; }
    .details-wrapper tr td:last-of-type, .details-wrapper tr th:last-of-type {
    display: none;
}
    #gorgias-chat-container {
  display: none !important;
}

    
.card {
  display: flex;
  flex-direction: column;
  gap: .5rem;
  padding: var(--card-pad);
  border: none;
  border-radius: var(--radius-sm);
  background: #fff;
  box-shadow: var(--shadow-sm);
}

.card .image-wrapper {
  position: relative;
}

.card img {
  width: 100%;
  aspect-ratio: var(--media-aspect);
  object-fit: cover;
  border-radius: var(--radius-sm);
  background: #fff;
}

.card h3 {
  margin: .25rem 0;
  font-size: 14px;
}

.card h3 a:before,
.card h3 a:after {
  content: '';
  display: none;
}

.card .meta {
  font-size: .85rem;
  color: var(--color-muted);
  line-height: 1.5;
}

.card .meta.price {
  color: #333;
  font-weight: 600;
}

.card .favorite-toggle {
  position: absolute;
  top: .75rem;
  right: .5rem;
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: .25rem;
}

.card .favorite-toggle .star {
  width: 22px;
  height: 22px;
  display: inline-block;
  background-size: contain;
  pointer-events: none;
}

.card .favorite-toggle .star {
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-star' viewBox='0 0 16 16'%3E%3Cpath d='M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z'/%3E%3C/svg%3E") no-repeat center;
}

.card .favorite-toggle.active .star {
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-star-fill' viewBox='0 0 16 16'%3E%3Cpath d='M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z'/%3E%3C/svg%3E") no-repeat center;
}

/* Variant table */
.card table {
  width: 100%;
  font-size: 6px;
  border-color: #fafafa;
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-sm);
  padding-bottom: .25rem;
}

.card thead {
  display: table-header-group;
  background: var(--color-bg-alt);
}

.card td {
  text-align: center;
}

.card tr:nth-child(even) {
  background: #fafafa;
}

.card th:nth-child(2),
.card th:nth-child(3),
.card th:nth-child(5),
.card td:nth-child(2),
.card td:nth-child(3),
.card td:nth-child(5) {
  text-align: center;
}

.details-wrapper input[type='number']::-webkit-outer-spin-button,
.details-wrapper input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

</style>
  </head>
  <body>
    <div id="print-catalog">${cardsHtml}</div>
  </body>
</html>`);
    printWindow.document.close();

    // Wait for images in the new window
    await new Promise((res) => {
      const imgs = printWindow.document.images;
      if (!imgs.length) return res();
      let loaded = 0;
      for (const img of imgs) {
        if (img.complete) {
          if (++loaded === imgs.length) res();
        } else {
          img.onload = img.onerror = () => {
            if (++loaded === imgs.length) res();
          };
        }
      }
    });

    printWindow.focus();
    printWindow.print();
  });
}


/* ---------- Saved carts (reworked) ---------- */
const LS_CARTS_KEY = "vibeWholesaleCarts";
let currentCartIdx = -1; // -1 = "New Saved Cart" pseudo-entry

function loadSavedCarts(){
  try { return JSON.parse(localStorage.getItem(LS_CARTS_KEY)||"[]"); }
  catch { return []; }
}
function saveSavedCarts(carts){
  localStorage.setItem(LS_CARTS_KEY, JSON.stringify(carts));
  hydrateSavedCartsUI(currentCartIdx);
}

function cartItemsCount(cart){
  return (cart.items || []).reduce((a,b)=>a + (Number(b.qty)||0), 0);
}

/**
 * Rebuilds the <select>, keeping the selection if possible.
 * selectedIdx: -1 for "New Saved Cart", or a valid array index.
 */
function hydrateSavedCartsUI(selectedIdx = -1){
  const select = $("#savedCartSelect");
  if (!select) return;

  const carts = loadSavedCarts();
  select.innerHTML = "";

  // Top pseudo-option
  const optNew = document.createElement("option");
  optNew.value = "-1";
  optNew.textContent = "New Saved Cart";
  select.appendChild(optNew);

  carts.forEach((c, idx) => {
    const opt = document.createElement("option");
    opt.value = String(idx);
    opt.textContent = `${c.name} — ${cartItemsCount(c)} items`;
    select.appendChild(opt);
  });

  // Clamp selection
  if (selectedIdx >= carts.length) selectedIdx = -1;
  currentCartIdx = selectedIdx;
  select.value = String(currentCartIdx);
}

function getCurrentCartPayload(){
  return Object.entries(qtyMap)
    .filter(([,q])=>Number(q)>0)
    .map(([sku, qty]) => ({ sku, qty:Number(qty)||0 }));
}

/* Select behavior:
 * -1 = "New Saved Cart": clears current working order (qtyMap) to start fresh
 * 0..N-1 = load that saved cart into qtyMap
 */
$("#savedCartSelect")?.addEventListener("change", (e)=>{
  const val = String(e.target.value || "-1");
  const idx = Number(val);
  currentCartIdx = isNaN(idx) ? -1 : idx;

  if (currentCartIdx === -1) {
    // Start a brand-new working cart (clear current qtyMap)
    qtyMap = {};
    // reflect into table inputs if already rendered
    document.querySelectorAll("input[data-sku]").forEach(i => (i.value = 0));
    renderOrder();
    return;
  }

  // Load existing saved cart
  const carts = loadSavedCarts();
  if (currentCartIdx < 0 || currentCartIdx >= carts.length) return;

  qtyMap = {};
  (carts[currentCartIdx].items || []).forEach(it => {
    qtyMap[it.sku] = Number(it.qty)||0;
  });

  // reflect into table inputs if already rendered
  Object.entries(qtyMap).forEach(([sku, qty])=>{
    const input = document.querySelector(`input[data-sku="${CSS.escape(sku)}"]`);
    if (input) input.value = qty;
  });
  renderOrder();
});

/* Save Current Cart = Overwrite the selected saved cart (must be an existing cart) */
$("#saveCurrentCartBtn")?.addEventListener("click", ()=>{
  const carts = loadSavedCarts();
  if (currentCartIdx === -1) {
    alert('Select an existing saved cart first, or use "Save as New".');
    return;
  }
  if (currentCartIdx < 0 || currentCartIdx >= carts.length) {
    alert("Selected cart not found.");
    return;
  }
  carts[currentCartIdx].items = getCurrentCartPayload();
  carts[currentCartIdx].savedAt = Date.now();
  saveSavedCarts(carts);
  alert(`Saved to "${carts[currentCartIdx].name}".`);
});

/* Save as New = Always create a new saved cart with a name */
$("#saveNewCartBtn")?.addEventListener("click", ()=>{
  const name = prompt("Name this cart:", "Untitled Cart");
  if (!name) return;
  const carts = loadSavedCarts();
  carts.push({ name, items:getCurrentCartPayload(), savedAt: Date.now() });
  saveSavedCarts(carts);
  // select the new one
  currentCartIdx = carts.length - 1;
  hydrateSavedCartsUI(currentCartIdx);
  alert(`Saved new cart "${name}".`);
});

/* Delete the currently selected saved cart */
$("#deleteCartBtn")?.addEventListener("click", ()=>{
  const carts = loadSavedCarts();
  if (currentCartIdx === -1) {
    alert("Select a saved cart to delete.");
    return;
  }
  if (currentCartIdx < 0 || currentCartIdx >= carts.length) {
    alert("Selected cart not found.");
    return;
  }
  if (!confirm(`Delete "${carts[currentCartIdx].name}"?`)) return;
  carts.splice(currentCartIdx, 1);
  // After delete, go back to "New Saved Cart" (keeps current working qtyMap untouched)
  currentCartIdx = -1;
  saveSavedCarts(carts);
  hydrateSavedCartsUI(currentCartIdx);
});

/* Boot UI on load (default to "New Saved Cart") */
hydrateSavedCartsUI(-1);


/* ---------- Import / Paste CSV (new) ---------- */
function parseCsv(text){
  const lines = text.split(/\r?\n/).map(l=>l.trim()).filter(Boolean);
  if (!lines.length) return [];
  const header = lines[0].toLowerCase();
  const start = (header.includes("sku") && header.includes("qty")) ? 1 : 0;
  const out = [];
  for (let i=start;i<lines.length;i++){
    const parts = lines[i].split(/,|\t|;/).map(s=>s.trim());
    if (parts.length < 2) continue;
    const sku = parts[0];
    const qty = Number(parts[1])||0;
    if (!sku || qty<=0) continue;
    out.push({sku, qty});
  }
  return out;
}
function applyCsv(text){
  const rows = parseCsv(text);
  let applied = 0, missing = [];
  rows.forEach(({sku, qty})=>{
    if (skuIndex[sku]) {
      qtyMap[sku] = qty;
      const input = document.querySelector(`input[data-sku="${CSS.escape(sku)}"]`);
      if (input) input.value = qty;
      applied++;
    } else {
      missing.push(sku);
    }
  });
  renderOrder();
  const log = [`Applied ${applied} line(s).`];
  if (missing.length) log.push(`Not found: ${missing.join(", ")}`);
  $("#csvResult") && ($("#csvResult").textContent = log.join("\n"));
}
$("#applyCsvBtn")?.addEventListener("click", ()=>{
  const paste = $("#csvPaste")?.value || "";
  const file = $("#csvFile")?.files?.[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = () => applyCsv(reader.result);
    reader.readAsText(file);
  } else if (paste.trim()) {
    applyCsv(paste);
  } else {
    $("#csvResult") && ($("#csvResult").textContent = "Nothing to import.");
  }
});

/* ---------- qtyMap persistence ---------- */
function saveQtyMap() {
  localStorage.setItem("vibe_qty_map", JSON.stringify(qtyMap));
}
function loadQtyMap() {
  const stored = localStorage.getItem("vibe_qty_map");
  return stored ? JSON.parse(stored) : {};
}

/* ---------- Click handling (favorites + filters dropdowns) ---------- */
document.addEventListener("click", (e) => {
  const target = e.target;

  // Toggle favorite
  const favBtn = target.closest(".favorite-toggle");
  if (favBtn) {
    toggleFavorite(favBtn.dataset.sku);
    return;
  }

  // Filter group dropdowns
  const group = target.closest("[data-filter-group]");
  const btn = target.closest("[data-dropdown-toggle]");
  const clearBtn = target.closest("[data-filter-group-reset]");

  const closeAllDropdowns = () => {
    document.querySelectorAll("[data-filter-group]").forEach((g) => {
      const b = g.querySelector("[data-dropdown-toggle]");
      const p = document.getElementById(b?.getAttribute("aria-controls"));
      if (b && p) {
        b.setAttribute("aria-expanded", "false");
        p.setAttribute("aria-hidden", "true");
        p.classList.add("m:hidden");
        g.classList.remove("filter-group--active");
      }
    });
  };

  if (btn) {
    const panel = document.getElementById(btn.getAttribute("aria-controls"));
    const isOpen = btn.getAttribute("aria-expanded") === "true";
    closeAllDropdowns();
    if (!isOpen && panel) {
      btn.setAttribute("aria-expanded", "true");
      panel.setAttribute("aria-hidden", "false");
      panel.classList.remove("m:hidden");
      group?.classList.add("filter-group--active");
    }
    e.preventDefault();
    return;
  }

  if (clearBtn && group) {
    const container = group.querySelector(".filter-group__list");
    container?.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
      cb.checked = false;
    });
    const groupName = group.getAttribute("data-filter-group");
    switch (groupName) {
      case "Type": updateTypeBtnLabel(); break;
      case "Metal": updateMetalBtnLabel(); break;
      case "Stone": updateStoneBtnLabel(); break;
    }
    updateLabel(
      group.querySelector("[data-dropdown-toggle]"),
      group.querySelector("[data-filter-group-values]")
    );
    debounced();
    e.preventDefault();
    return;
  }

  // Click outside closes all
  if (!target.closest("[data-filter-group]")) closeAllDropdowns();

  // Sort panel toggle/close
  if (sortBtn && sortBtn.contains(target)) {
    sortPanel?.classList.toggle("m:hidden");
    return;
  }
  if (sortPanel && !sortPanel.classList.contains("m:hidden") &&
      !sortBtn?.contains(target) &&
      !sortPanel.contains(target)) {
    sortPanel.classList.add("m:hidden");
  }
});

/* ---------- Bootstrap ---------- */
fetchSheet()
  .then((rows) => {
        console.debug('[wholesale] rows fetched:', rows?.length || 0);

    // Build skuIndex for totals + order display
    rows.forEach((r) => {
      const sku = r["Variant SKU"];
      if (!sku) return;
      skuIndex[sku] = {
        title: (r.Title || "").includes("-")
          ? r.Title.slice(0, r.Title.lastIndexOf("-")).trim()
          : (r.Title || sku),
        size: sku.split("-").pop(),
        retail: toNumber(r["Variant Price"] || r.SRP),
        wholesale: toNumber(r["Wholesale Price"]),
        base: sku.split("-").slice(0, -1).join("-") || sku,
        metal: metalCategory(r.Metal || ""),
        stone: r.Stone || ""
      };
    });
    return rows;
  })
  .then(groupByBaseSKU)
  .then((groups) => {
    allGroups = groups;
    populateFilters();
    updateFilterOptions();
    applyFilters();
    initFilterGroups();
    hydrateSavedCartsUI();
    renderOrder();
    rebuildActiveFacets();
  })
  .catch(console.error);


  })();